import { isPickupSpot, isPublicFarmStand } from "./farmStandPublic";
import { LOCATION_SOURCES, normalizeCoordinates } from "./locationUtils";
import { hasPublicStandCoordinates } from "./standLocation";

const CURRENT_BROWSER_LOCATION_SOURCES = new Set([
  LOCATION_SOURCES.BROWSER_GPS,
]);

export const getFarmStandMapPoint = (stand = {}) => {
  if (!hasPublicStandCoordinates(stand)) return null;

  const lat = Number(stand.publicLat);
  const lng = Number(stand.publicLng);

  return { lat, lng };
};

export const isFarmStandMapEligible = (stand = {}) =>
  isPublicFarmStand(stand) &&
  stand.isPublic !== false &&
  stand.visibility !== "private" &&
  Boolean(getFarmStandMapPoint(stand));

export const getFarmStandMapType = (stand = {}) =>
  isPickupSpot(stand) ? "pickup_spot" : "farm_stand";

export const isMarketplaceProductMainMapEligible = () => false;

export const getRenderableUserLocationMarkerPoint = (locationData = {}) => {
  const coords = normalizeCoordinates(locationData);
  if (!coords) return null;

  const source = String(locationData.locationSource || locationData.source || "").trim();
  if (!CURRENT_BROWSER_LOCATION_SOURCES.has(source)) return null;

  return coords;
};
